module.exports = "<div>Favor aguarde...</div>\r\n<a *ngIf=\"false\" href=\"unauthorized.component.html\">unauthorized.component.html</a>\r\n"